import Vue from 'vue';
import VueI18n from 'vue-i18n';
Vue.use(VueI18n);
var i18n = new VueI18n({
  locale: navigator.language,
  silentTranslationWarn: true
}); // // Set locale to 'en' in dev mode.
// let lang = (.env) ? 'en' : (navigator.language).substring(0,2);
//
// // As we are getting languages from the database, the locale 'en' is just for it to not give an error.
// axios.post(process.env.BASE_API_URL + '/translations', { language: lang})
//   .then(function (response) {
//     i18n.setLocaleMessage('en', response.data)
//   })
//   .catch(error => {
//     console.log(error);
// });

export default (function (_ref) {
  var app = _ref.app;
  // Set i18n instance on app
  app.i18n = i18n;
}); // if you need to import it from
// other files, then:

export { i18n };